import React from 'react'
import Navbar from '../inc/Navbar'
import MITSUBISHIac from "../images/MITSUBISHI ELECTRIC AC Slider.jpg"
import { Link } from 'react-router-dom'
import splitac from "../images/Split Air Conditioners.jpg";
import CeilingCassette from "../images/Ceiling Cassette.jpg";
import CeilingConcealed from "../images/Ceiling Concealed.jpg";
import CityMultiVRFSystem from "../images/City Multi VRF System.jpg";
import LossnayVentilationProducts from "../images/Lossnay & Ventilation Products.jpg";
import AirCurtain from "../images/Air Curtain.jpg";
import WindowAirConditioners from "../images/Window Air Conditioners.jpeg";
import AirflowCompactCassette4Way from "../images/4-Way Airflow Compact Cassette.jpg"
import AirflowCassette2Way from "../images/2 Way Airflow Cassette.jpg";
import AirflowCassette1Way from "../images/1-Way Airflow Cassette.jpg";
import FreshAirIntake from "../images/Fresh Air Intake.jpg";
import CeilingSuspended from "../images/Ceiling Suspended.jpg";
import WallMounted from "../images/Wall Mounted.jpg";
import FloorStandingExposed from "../images/Floor Standing Exposed.jpg";
import FloorStandingPackaged from "../images/Floor Standing Packaged.jpg"


function Mitsubishi() {
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />
      <br />
      <div className='ackrishnagar'>
        <div className="album py-1">
          <div className="container mt-2">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                <li className="breadcrumb-item active" aria-current="page">Mitsubishi</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <img src={MITSUBISHIac} className="d-block w-100" alt="MITSUBISHIac_krishnagar" />
      <br />
      <div className="album py-1 ">

        <div className="container mt-2">
          <center>
            <h3 className='mb-3' style={{ color: "grey" }}><b>Air Conditioning Systems</b></h3>
            <h5>Saha Refrigeration & Air Conditions is a trusted and authorized distributor of world-class air conditioning systems for residential, commercial, and industrial applications. We are committed to delivering advanced cooling solutions designed to perform efficiently in diverse and demanding climatic conditions</h5>
          </center>
          <br />
        </div>
      </div>

      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={CeilingCassette} className="card-img-top" alt="CeilingCassette" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">4-Way Airflow Ceiling Cassette </h5>
                  <p className="card-text describe mb-2"><small>Cooling Guaranteed Operating Range Upper Limit °CDB 46, Lower Limit °CDB -15
                    Heating Guaranteed Operating Range Upper Limit °CDB 24 Lower Limit °CDB -10
                    Rated operating conditions
                    Cooling - Indoor: 27°C(80°F)DB, 19°C(66°F)WB, Outdoor: 35°C(95°F)DB
                    Heating - Indoor: 20°C(68°F)DB, Outdoor: 7°C(45°F)DB, 6°C(43°F)WB
                    Refrigerant piping length (one-way): 7.5m(25ft)
                    Product image and color shown on digital platform may appear different than actual product.
                    Product specifications & Design are subject to change without prior notice for further improvement.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

               <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={AirflowCompactCassette4Way} className="card-img-top" alt="4-Way Airflow Compact Cassette"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">4-Way Airflow Compact Cassette </h5>
                  <p className="card-text describe mb-2"><small>Model	PLFY-P15VFM	PLFY-P20VFM	PLFY-P25VFM	PLFY-P32VFM	PLFY-P40VFM	PLFY-P50VFM
Power source	1-phase 220-240V 50Hz/220V 60Hz
Cooling capacity	kW	1.7	2.2	2.8	3.6	4.5	5.6
BTU/h	5800	7500	9600	12300	15400	19100
Heating capacity	kW	1.9	2.5	3.2	4.0	5.0	6.3</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>


<div className="col-md-4 mt-3">
              <div className="card" >
                <img src={AirflowCassette2Way} className="card-img-top" alt="4-Way Airflow Compact Cassette"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">2-Way Airflow Cassette</h5>
                  <p className="card-text describe mb-2"><small>
Model	PLFY-P20VLMD	PLFY-P25VLMD	PLFY-P32VLMD	PLFY-P40VLMD
Power source	1-phase 220-240V 50Hz / 1-phase 220-230V 60Hz
Cooling capacity	kW*1	2.2	2.8	3.6	4.5
BTU/h*1	7500	9600	12300	15400
Heating capacity	kW*1	2.5	3.2	4.0	5.0</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={AirflowCassette1Way} className="card-img-top" alt="1-Way Airflow Cassette"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">1-Way Airflow Cassette</h5>
                  <p className="card-text describe mb-2"><small>
Model	PMFY-P20VBM	PMFY-P25VBM	PMFY-P32VBM	PMFY-P40VBM
Power source	1-phase 220-240V 50Hz / 1-phase 220V 60Hz
Cooling capacity	kW*1	2.2	2.8	3.6	4.5
BTU/h*1	7500	9600	12300	15400
Heating capacity	kW*1	2.5	3.2	4.0	5.0
BTU/h*1	8500	10900	13600	17100</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>


              <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={FreshAirIntake} className="card-img-top" alt="Fresh Air Intake" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Fresh Air Intake</h5>
                  <p className="card-text ptext mb-2"><small>
                    *1 Cooling capacity indicates the maximum value at operation under the following condition. Cooling: Indoor 33°CDB/28°CWB, Outdoor 33°CDB. The set temperature of the remote controller is 18°C
*2 The value are measured at the factory setting of airflow mode and external static pressure
*3 Heating capacity indicates the maximum value at operation under the following condition. Heating: Indoor 0°CDB/-2.9°CWB, Outdoor 0°CDB/-2.9°CWB. The set temperature of the remote controller is 25°C.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>



 <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={CeilingSuspended} className="card-img-top" alt="Ceiling Suspended" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Ceiling Suspended</h5>
                  <p className="card-text ptext mb-2"><small>
                   1 Cooling/Heating capacity indicates the maximum value at operation under the following condition. Cooling Indoor : 27°C(80.6°F)DB/19°C(66.2°F)WB, Outdoor 35°C(95°F)DB Heating Indoor : 20°C(68°F)DB, Outdoor 7°C(44.6°F)DB/6°C(42.8°F)WB
*2 Airflw rate/Sound pressure level are shown in (low-middle 2-middle 1-high).
*3 It is measured in anechoic room.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={CeilingConcealed} className="card-img-top" alt="CeilingConcealed" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Ceiling Concealed</h5>
                  <p className="card-text mb-2"><small>
                    Ceiling Concealed
                    Inverter - Winter and Summer Series
                    SEZ/PEAD Series</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

              <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={WallMounted} className="card-img-top" alt="Wall Mounted"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Wall Mounted</h5>
                  <p className="card-text mb-2"><small>1  Nominal cooling conditions (subject to JIS B8615-1) Indoor : 27°CD.B./19°CW.B. (81°FD.B./66°FW.B.), Outdoor 35°CD.B. (95°FD.B.) Pipe length : 7.5 m (24-9/16 ft.), Level difference : 0 m (0 ft.)
*2  Nominal heating conditions (subject to JIS B8615-1) Indoor : 20°CD.B. (68°FD.B.), Outdoor 7°CD.B./6°CW.B (45°FD.B./43°FW.B.) Pipe length : 7.5 m (24-9/16 ft.), Level difference : 0 m (0 ft.)</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>



<div className="col-md-4 mt-3">
              <div className="card" >
                <img src={FloorStandingExposed} className="card-img-top" alt="Floor Standing Exposed"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Floor Standing Exposed</h5>
                  <p className="card-text mb-2"><small>Cooling/Heating capacity indicates the maximum value at operation under the following condition.
  Cooling Indoor : 27°C(81°F)DB/19°C(66°F)WB, Outdoor 35°C(95°F)DB
  Heating Indoor : 20°C(68°F)DB, Outdoor 7°C(45°F)DB/6°C(43°F)WB
*2  Air flow rate/Sound pressure level are in (Low-High)</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>



<div className="col-md-4 mt-3">
              <div className="card" >
                <img src={FloorStandingPackaged} className="card-img-top" alt="Floor Standing Packaged"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Floor Standing Packaged</h5>
                  <p className="card-text mb-2"><small>*1  Nominal cooling conditions
  Indoor: 27°CD.B./19°CW.B. (81°FD.B./66°FW.B.), Outdoor: 35°CD.B. (95°FD.B.)
  Pipe length: 7.5 m (24-9/16 ft.), Level difference: 0 m (0 ft.)
*2  The values are measured at the factory setting of external static pressure.
*3  Nominal heating conditions
  Indoor: 20°CD.B. (68°FD.B.), Outdoor: 7°CD.B./6°CW.B. (45°FD.B./43°FW.B.)
  Pipe length: 7.5 m (24-9/16 ft.), Level difference: 0 m (0 ft.)</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>



              <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={CityMultiVRFSystem} className="card-img-top" alt="City Multi VRF System"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> City Multi VRF System</h5>
                  <p className="card-text mb-2"><small>Self-developed Compressor
The compressor is the heart of an air conditioner, contains inverter control.
Mitsubishi Electric manages all compressor production processes, from development, design, and manufacture to quality control. We develop high-performance compressors to improve performance to a higher level.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>

               <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={LossnayVentilationProducts} className="card-img-top" alt="LossnayVentilationProducts"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Lossnay & Ventilation Products</h5>
                  <p className="card-text mb-2"><small>Excellent air quality and unbeatable Heat Exchange Efficiency | <b>LGH series</b>
Minimal Energy Loss, Maximum Heat Recovery, Substantial Energy Savings, <b>GUF series</b>
Exceptionable Air Quality, Highly Efficient Humidification, Substantial Energy Savings</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
               <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={AirCurtain} className="card-img-top" alt="AirCurtain"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Air Curtain</h5>
                  <p className="card-text mb-2"><small>Air Curtain
Mitsubishi Electric Air Curtains are the perfect way to provide your premises with a comfortable, clean and hygienic environment while saving energy with a quiet, efficient and powerful operation. <b>GK Series</b> Mitsubishi Air Curtains are the perfect way to provide your premises with a comfortable, clean and hygienic environment while saving energy with a quiet, efficient and powerful operation.</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>


             <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={WindowAirConditioners} className="card-img-top" alt="WindowAirConditioners"/>
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Window Air Conditioners</h5>
                  <p className="card-text mb-2"><small>Range of Powerful Yet Elegant Air Conditioners

<b>RWM-AE</b></small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">
              <div className="card" >
                <img src={splitac} className="card-img-top" alt="splitac" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> Split Air Conditioners</h5>
                  <p className="card-text mb-2"><small>Split Air Conditioners
                    Range Of Most Powerful Yet Elegant Air Conditioners | MSZ-HP, RAZ-SE </small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>

                </div>
              </div>
            </div>








          </div>
        </div>
      </div>
      <br />

    </div>
  )
}

export default Mitsubishi